import { useQuery } from '@tanstack/react-query';
import { api } from '../api';
import { can } from '../auth/me';
import { useMe } from '../auth/useMe';
import { CREW_KEY, CREW_RESOURCE, dayShort } from './types';

/** „Dostępność ludzi” (review L5: the list needs its „Podgląd” too). */
const PEOPLE_AVAILABILITY = 'crew.people_availability';

/**
 * Production 2026-10-26: people marked „Niedostępny” on days of an event (`GET /api/crew/events/:id/unavailable`, a
 * mark by hours only where it meets the event) — every person picker greys them out with the days, so a pick the server
 * would refuse cannot be made. personId → the days.
 */
export type UnavailableDays = ReadonlyMap<string, readonly string[]>;

export function useUnavailable(eventId: string, enabled: boolean, own?: { startsAt: string; endsAt: string } | null): UnavailableDays {
  const { me } = useMe();
  const allowed = !!me && can(me, CREW_RESOURCE, 'create') && can(me, PEOPLE_AVAILABILITY, 'view');
  // review L5: own hours („Tylko część wydarzenia”) — a mark by hours counts only where it meets them
  const query = own ? `?${new URLSearchParams(own).toString()}` : '';
  const q = useQuery({
    queryKey: [...CREW_KEY, 'unavailable', eventId, query],
    enabled: enabled && allowed,
    retry: false,
    queryFn: () => api<{ people: Array<{ personId: string; days: string[] }> }>(`/api/crew/events/${eventId}/unavailable${query}`),
  });
  return new Map((q.data?.people ?? []).map((p) => [p.personId, p.days]));
}

/** The days of `days` the person is unavailable (none: free to pick). */
export const blockedDays = (u: UnavailableDays, personId: string, days: readonly string[]): string[] => (u.get(personId) ?? []).filter((d) => days.includes(d));

/** „Karol Zbaracki — niedostępny 26.10” (the option of a person who cannot be picked). */
export const unavailableLabel = (name: string, days: readonly string[]): string => `${name} — niedostępny ${days.map(dayShort).join(', ')}`;
